"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconDeliverySvg = function IconDeliverySvg(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.3 0a.5.5 0 0 1 .5.5l-.001 2.608 8.301.001a.5.5 0 0 1 .45.282l.03.077 1.525 5.187 4.55 1.474a.5.5 0 0 1 .337.385l.008.091V17.6a.5.5 0 0 1-.5.5l-5.135-.001c-.25 1.76-1.798 3.11-3.665 3.11s-3.415-1.35-3.665-3.11H10.9l-1.6.001a.51.51 0 0 1-.01 0H.5a.5.5 0 0 1-.5-.5V.5A.5.5 0 0 1 .5 0zm6.4 14.991l-.171.005a2.76 2.76 0 0 0-.955.232l-.144.07a2.682 2.682 0 0 0-.975.853A2.55 2.55 0 0 0 13 17.606c.004 1.435 1.208 2.603 2.7 2.603 1.494 0 2.7-1.171 2.7-2.609a2.556 2.556 0 0 0-.01-.227l.005.061a2.532 2.532 0 0 0-.024-.216l.008.054a2.522 2.522 0 0 0-.172-.642l.011.027a2.574 2.574 0 0 0-.459-.744 2.684 2.684 0 0 0-1.133-.765 2.783 2.783 0 0 0-.926-.157zM8.8 1H1v16.1h7.8zm8.926 3.109H9.799V17.1l2.237-.002.01-.067a3.528 3.528 0 0 1 .866-1.804 3.681 3.681 0 0 1 1.429-.985 3.773 3.773 0 0 1 2.002-.197 3.724 3.724 0 0 1 1.106.374l.062.034a3.608 3.608 0 0 1 1.854 2.645l4.634.002v-6.132l-4.453-1.442a.5.5 0 0 1-.289-.244l-.037-.09zM13.3 6.218a.5.5 0 0 1 .492.41l.008.09v1.831l2.7.001a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492l-.09.008h-3.2a.5.5 0 0 1-.492-.41l-.008-.09V6.718a.5.5 0 0 1 .5-.5z"
  }));
};

IconDeliverySvg.defaultProps = {
  viewBox: "0 0 25 22",
  xmlns: "http://www.w3.org/2000/svg"
};

var IconDelivery = function IconDelivery(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'gray800' : _ref$color,
      measure = _ref.measure,
      rest = _objectWithoutProperties(_ref, ["color", "measure"]);

  return /*#__PURE__*/_react.default.createElement(_index.IconStyled, _extends({
    $color: color,
    $measure: measure
  }, rest), /*#__PURE__*/_react.default.createElement(IconDeliverySvg, null));
};

IconDelivery.displayName = 'IconDelivery';
var _default = IconDelivery;
exports.default = _default;